module.exports = __webpack_public_path__ + "media/images/categories/headers/education-f27e479b9b6b3f4b094f004e24b77b2e.jpg";